import { createSlice } from "@reduxjs/toolkit";
import { AlertType } from "../types/alertType";

interface IAlertState {
  data: AlertType[];
}

const initialState: IAlertState = {
  data: [],
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setAlert: (state, action) => {
      const { payload } = action;
      state.data = [...state.data, payload];
    },
  },
});

export const { setAlert } = alertSlice.actions;

export default alertSlice.reducer;
